import styles from './FJSourcePreviewItemBtu.module.less';
import { memo, useState } from 'react';
import FJCheckBox from '../../../common/components/FJCheckBox/FJCheckBox';
import FJToolTip from '../../../common/components/FJToolTip/FJToolTip';
import ComparisonIcon from '../../../assets/svg/comparison.svg?react';
import DeleteIcon from '../../../assets/svg/delete.svg?react';
import FJLoading from '../../../common/components/FJLoading/FJLoading';
import DownloadIcon from '../../../assets/svg/download.svg?react';
import FJIconButton from '../../../common/components/FJIconButton/FJIconButton';
import FJHistoryVideoEditIcon from '../../../assets/svg/community/trim-video-Edit.svg?react';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import FJConfig from '../../../config/FJConfig';
import FJAppConstant from '../../../constants/FJAppConstant';
import PropTypes from 'prop-types';
import FJMessageStore from '../../../store/FJMessageStore';
import FJConstant from '../../../constants/FJConstant';
import AddToMediaIcon from '../../../assets/base64/media-gradient.js';
import FJUtil from '../../../util/FJUtil.js';
import FJPrivacySetting from '../../FJCommunity/FJCommonComponent/FJPrivacySetting/FJPrivacySetting.jsx';
import FJShareSettingIcon from '../../../assets/svg/community/share-setting.svg?react';
import FJCommunityUtil from '../../../util/FJCommunityUtil.js';

const FJSourcePreviewItemBtu = memo(props => {
    const {
        selected = false,
        propsIsHover = false,
        shareKey = '',
        privacyStatus = '',
        loadStatus,
        sourceLoadStatus,
        sourceOriginLoadStatus,
        isComparison,
        onReloadOrigin,

        isShowPrivacyStatus = false,
        isShowSelected = false,
        hideCompare = true,
        hideDelete = false,
        hideDownload = false,
        hideEdit = true,
        hideSelect = false,
        isShowAddToMediaButton = false,
        isApplyButton = false,
        isShowAddToEditPageButton = false,

        onApplyMedia,
        onSelected,
        onDelete,
        onDownload,
        onEdit,
        setIsComparison,
        onPrivacySettingChange,
        onAddToEditPage,
    } = props;
    const isShowCheck = !hideSelect && loadStatus !== FJConstant.PROGRESS;

    const [stateIsDownloadLoading, setStateIsDownloadLoading] = useState(false);
    const [stateIsEditLoading, setStateIsEditLoading] = useState(false);
    const [stateIsAddToEditPageLoading, setStateIsAddToEditPageLoading] = useState(false);

    const _forbidEvent = e => {
        e.stopPropagation();
    };

    const _onSelected = (bool, e) => {
        e.stopPropagation();
        onSelected && onSelected(bool, e);
    };

    const _compareMouseDown = () => {
        if (sourceLoadStatus === FJConstant.ERROR || sourceOriginLoadStatus === FJConstant.ERROR) {
            FJMessageStore.addMessage(FJLocalStore._('failed-to-preview-please-try-again'), 'error');
            onReloadOrigin && onReloadOrigin();
            return;
        }
        if (isComparison || sourceOriginLoadStatus !== FJConstant.SUCCESS) return;
        setIsComparison(true);

        const _onMouseUp = () => {
            setIsComparison(false);
            FJUtil.removeEvent(document.body, 'mouseup', _onMouseUp);
        };
        FJUtil.addEvent(window, 'mouseup', _onMouseUp);
    };

    const _onDelete = e => {
        e.stopPropagation();
        onDelete && onDelete();
    };

    const _onDownload = e => {
        e.stopPropagation();
        if (stateIsDownloadLoading) {
            return;
        }
        setStateIsDownloadLoading(true);
        onDownload && onDownload(() => setStateIsDownloadLoading(false));
    };

    const _onEdit = e => {
        e.stopPropagation();
        setStateIsEditLoading(true);
        onEdit &&
            onEdit(() => {
                setStateIsEditLoading(false);
            });
    };

    const _onAddToEditPage = e => {
        e.stopPropagation();
        const __callback = status => {
            if (status === FJConstant.SUCCESS) {
                setStateIsAddToEditPageLoading(false);
            } else {
                setStateIsAddToEditPageLoading(true);
            }
        };
        onAddToEditPage && onAddToEditPage(e, __callback);
    };

    return (
        <>
            {isShowCheck && (
                <FJCheckBox
                    selected={selected}
                    dataChange={_onSelected}
                    className={classNames(styles.checkbox, {
                        [styles.checkbox_show]: selected || propsIsHover,
                    })}
                />
            )}
            {!isShowSelected && (
                <div
                    className={classNames(styles.header_right, {
                        [styles.header_right_show]:
                            propsIsHover &&
                            ((loadStatus !== FJConstant.PROGRESS && loadStatus !== FJConstant.LOADING) ||
                                loadStatus === FJConstant.SUCCESS),
                    })}
                >
                    {!hideCompare && (
                        <FJToolTip title={'compare'}>
                            <div
                                className={styles.hover_icon_box}
                                onMouseDown={_compareMouseDown}
                                onClick={_forbidEvent}
                            >
                                <ComparisonIcon />
                            </div>
                        </FJToolTip>
                    )}
                    {!hideDelete && (
                        <FJToolTip title={'delete'}>
                            <div className={styles.hover_icon_box} onClick={_onDelete}>
                                <DeleteIcon className={styles.delete_icon} />
                            </div>
                        </FJToolTip>
                    )}
                    {!hideDownload && (
                        <FJToolTip title={'download'}>
                            <div className={styles.hover_icon_box} onClick={_onDownload}>
                                {stateIsDownloadLoading ? (
                                    <FJLoading style={{ width: 16, height: 16 }} />
                                ) : (
                                    <DownloadIcon />
                                )}
                            </div>
                        </FJToolTip>
                    )}
                    {isShowPrivacyStatus && (
                        <FJPrivacySetting
                            value={privacyStatus}
                            onChange={onPrivacySettingChange}
                            shareKey={shareKey}
                            placement='rightTop'
                            offsetTop={-1}
                            offsetLeft={6}
                            isNeedBindWheelEvent={true}
                            renderTrigger={({ ref, onClick }) => {
                                const _onClick = e => {
                                    e.stopPropagation();
                                    onClick(e);
                                };
                                return (
                                    <FJToolTip title='visibility'>
                                        <div className={styles.hover_icon_box} ref={ref} onClick={_onClick}>
                                            <FJShareSettingIcon className={styles.privacy_icon} />
                                        </div>
                                    </FJToolTip>
                                );
                            }}
                        />
                    )}
                    {isShowAddToMediaButton && (
                        <div className={styles.add_to_media_button} onClick={onApplyMedia}>
                            <img src={AddToMediaIcon} className={styles.media_icon} />
                            <div className={styles.media_text}>{FJLocalStore._(isApplyButton ? 'apply' : 'media')}</div>
                        </div>
                    )}

                    {isShowAddToEditPageButton && (
                        <FJToolTip title={'edit'}>
                            <div
                                className={classNames(styles.add_to_edit_page_button, styles.hover_icon_box)}
                                onClick={_onAddToEditPage}
                            >
                                {stateIsAddToEditPageLoading && (
                                    <div className={styles.add_to_edit_page_loading}>
                                        <FJLoading style={{ width: 16, height: 16 }} />
                                    </div>
                                )}
                                <div
                                    className={classNames(styles.add_to_edit_page_box, {
                                        [styles.hide]: stateIsAddToEditPageLoading,
                                    })}
                                >
                                    <FJHistoryVideoEditIcon />
                                </div>
                            </div>
                        </FJToolTip>
                    )}
                </div>
            )}
            {!hideEdit && (
                <FJIconButton
                    className={classNames(styles.use_this, {
                        [styles.use_this_loading]: stateIsEditLoading,
                        [styles.photo_remove_bg_edit]:
                            FJConfig.appType === FJAppConstant.PHOTO_REMOVE_BG ||
                            FJConfig.appType === FJAppConstant.VIDEO_REMOVE_BG,
                        [styles.use_this_show]: propsIsHover && !isShowSelected && loadStatus === FJConstant.SUCCESS,
                    })}
                    textClassName={styles.use_this_text}
                    text={FJLocalStore._('adjust')}
                    onClick={_onEdit}
                    isLoading={stateIsEditLoading}
                />
            )}
        </>
    );
});

FJSourcePreviewItemBtu.displayName = 'FJSourcePreviewItemBtu';

FJSourcePreviewItemBtu.propTypes = {
    isShowSelected: PropTypes.bool,
    hideCompare: PropTypes.bool,
    hideDelete: PropTypes.bool,
    hideDownload: PropTypes.bool,
    hideEdit: PropTypes.bool,
    hideSelect: PropTypes.bool,
    selected: PropTypes.bool,
    onSelected: PropTypes.func,
    onDelete: PropTypes.func,
    onDownload: PropTypes.func,
    onEdit: PropTypes.func,
    onForbidEvent: PropTypes.func,
    propsIsHover: PropTypes.bool,
    isComparison: PropTypes.bool,
    setIsComparison: PropTypes.func,
    sourceLoadStatus: PropTypes.string,
    sourceOriginLoadStatus: PropTypes.string,
    onReloadOrigin: PropTypes.func,
    isShowAddToMediaButton: PropTypes.bool,
    isApplyButton: PropTypes.bool,
    onApplyMedia: PropTypes.func,
    isShowAddToEditPageButton: PropTypes.bool,
    onAddToEditPage: PropTypes.func,
    loadStatus: PropTypes.string,
    shareKey: PropTypes.string,
    privacyStatus: PropTypes.string,
    isShowPrivacyStatus: PropTypes.bool,
    onPrivacySettingChange: PropTypes.func,
};
export default FJSourcePreviewItemBtu;
